const doc = [({"en":({"js":({"routes":({"user":({"unsubscribed":({"you_have_been_unsubscribed":"You have been unsubscribed."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;